import React from 'react';
import { api } from '../../api'
import {Pagination} from "@material-ui/lab";
import {StyledInput} from "../../component/Typeset";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardHeader from "@material-ui/core/CardHeader";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

export const useStyles = makeStyles({
    buttonStyleFilled: {
        background: '#F62459',
        color: '#FFF',
        marginLeft: '10px',
        height: '40px',
        '&:hover': {
            background: '#C93756'
        },
    },
    textWhite: {
        color: 'white',
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 400,
    },
    paginationRoot: {
        color: 'white',
        '& .MuiPaginationItem-root': {
            color: 'white'
        },
        '& .MuiPaginationItem-page.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        }
    }
});

export const useCardStyles = makeStyles({
    card: {
        backgroundColor: '#4a5557',
        color: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: 8,
    },
    buttonStyle: {
        color: 'white',
    },
    buttonStyleFilled: {
        background: '#F62459',
        color: '#FFF',
        padding: '8px 20px',
        '&:hover': {
            background: '#C93756'
        },
    },
    title: {
        fontSize: '1rem'
    },
    subtitle:  {
        fontSize: '0.8rem',
    },
});

const TicketCard = ({event_thumbnail_url, ticket_transfer_uri, event_title, event_start_at, event_end_at, ticket_tier, ...props }) => {
    const classes = useCardStyles();
    const startStr = moment(event_start_at).format('D MMM YYYY [at] HH:mm')
    const endStr = moment(event_end_at).format('D MMM YYYY [at] HH:mm')
    const ticketPrice = parseFloat(props.ticket_transfer_price) + parseFloat(props.actual_booking_fee)
    const getUrl = window.location;
    const baseUrl = getUrl.protocol + '//' + getUrl.host + '/resale/';

    return (
        <Card className={classes.card}>
            <div style={{
                width: '100%',
                position: 'relative'
            }}>
                <CardMedia
                    style={{
                      maxHeight: '100px',
                    }}
                    src={event_thumbnail_url}
                    component={'img'}
                />
                <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'inline-block',
                    position: "absolute",
                    bottom: '0',
                    width: '100%',
                    padding: 16,
                    color: 'rgba(255, 255, 255, 0.85)'
                }}>{event_title}
                    <div className={classes.subtitle}>
                        <span style={{whiteSpace: 'nowrap'}}>
                            <span style={{width: 50, display: 'inline-block'}}>Start:</span>{startStr}
                        </span>
                        <br/>
                        <span style={{whiteSpace: 'nowrap'}}>
                            <span style={{width: 50, display: 'inline-block'}}>End:</span>{endStr}
                        </span>
                    </div>
                </div>
            </div>
            <CardHeader
                title={
                    <div style={{display: 'flex', width: '100%', alignItems: 'center'}}>
                        <div style={{flex: 1}}>
                            <div style={{fontSize: '0.8rem'}}>Ticket tier</div>
                            {ticket_tier}
                        </div>
                        <a href={`${baseUrl}${ticket_transfer_uri}`} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
                            <Button
                                color="primary"
                                className={classes.buttonStyleFilled}
                            >
                                {props.currency.slice(-1)}{ticketPrice}
                            </Button>
                        </a>
                    </div>
                }
                titleTypographyProps={{
                    className: classes.title
                }}
            />
            <div style={{flex: 1}} />
        </Card>
    )
}

const Resale = () => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = React.useState('');
    const [tickets, setTickets] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        setPage(value);
    };

    const getList = React.useCallback(() => {
        setIsLoading(true);
        api.get(`triniq_ticket/v1/resale/?page=${page}&search=${searchStr}`).then(
            (response) => {
                setTickets(response.data);
                setIsLoading(false);
            }
        )
    }, [page, searchStr]);

    React.useEffect(() => {
        getList();
    }, [page]);

    return (
        <div style={{paddingBottom: '30px'}}>
            <div style={{justifyContent: 'flex-end', display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '20px'}}>
                <div>
                    <StyledInput
                        style={{width: '200px', marginBottom: 0}}
                        type="search"
                        value={searchStr}
                        placeholder={'e.g. Early Bird'}
                        onChange={(e) => setSearchStr(e.target.value)}
                    />
                    <Button
                        onClick={() => getList()}
                        color="primary"
                        className={classes.buttonStyleFilled}
                    >
                        <SearchIcon />
                    </Button>
                </div>
            </div>

            {!isLoading ?
                (
                    <Grid container spacing={2}>
                        {tickets && tickets.results && tickets.results.map((ticket, idx) => (
                            <Grid item md={4} sm={4} xs={12} key={'ticket_' + ticket.ticket_transfer_uri}>
                                <TicketCard
                                    {...ticket}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <CircularProgress style={{color: 'white'}} size={24} />
                )
            }
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0'}}>
                <Pagination
                    className={classes.paginationRoot}
                    count={tickets.count ? Math.ceil(tickets.count / 12) : 1}
                    page={page}
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}

export default Resale;
